import Price from './price'

const dataShims = {
  smallunits: 'smallUnits',
  hascompactunitsview: 'hasCompactUnitsView',
  classname: 'className',
}

$('.js__price').each(function() {
  const data = $(this).data()

  Object.keys(dataShims).forEach(key => {
    data[dataShims[key]] = data[key]
  })

  $(this).reactify(Price, data)
  $(this).children().unwrap()
})
